import { ReactComponent as BlueColorIcon } from 'assets/icons/BlueColorIcon.svg';
import { ReactComponent as BlueGreenColorIcon } from 'assets/icons/BlueGreenColorIcon.svg';
import { ReactComponent as BlueRedColorIcon } from 'assets/icons/BlueRedColorIcon.svg';
import { ReactComponent as BlueYellowColorIcon } from 'assets/icons/BlueYellowColorIcon.svg';
import { ReactComponent as GreenColorIcon } from 'assets/icons/GreenColorIcon.svg';
import { ReactComponent as RedColorIcon } from 'assets/icons/RedColorIcon.svg';

export const OPTION_TYPES = {
  GREEN: 'green',
  RED: 'red',
  BLUE: 'blue',
  BLUE_GREEEN: 'blueGreen',
  BLUE_RED: 'blueRed',
  BLUE_YELLOW: 'blueYellow',

} as const;

export const OPTIONS = [
  { color: OPTION_TYPES.GREEN, icon: <GreenColorIcon /> },
  { color: OPTION_TYPES.RED, icon: <RedColorIcon /> },
  { color: OPTION_TYPES.BLUE, icon: <BlueColorIcon /> },
  { color: OPTION_TYPES.BLUE_GREEEN, icon: <BlueGreenColorIcon /> },
  { color: OPTION_TYPES.BLUE_RED, icon: <BlueRedColorIcon /> },
  { color: OPTION_TYPES.BLUE_YELLOW, icon: <BlueYellowColorIcon /> },
] as const;
